// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tmAf","footer":"styles_footer__-74Hn"};